import React, { Component } from 'react';
import './App.css';
import Header from '../components/Header/Header';
import Main from '../components/Main/Main';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Signup from './Signup/Signup';
import {connect} from 'react-redux';
import Feed from './Suggestions/Suggestions';
import MyProfile from './MyProfile/MyProfile';
import UserProfile from './UserProfile/UserProfile';
import Messages from '../containers/Messages/Messages';
import axios from 'axios';
import Explore from './Explore/Explore';
import Admin from './Admin/Admin';

class App extends Component {

  constructor(props) {
    super(props);
    if(this.props.loginStatus.authToken === ''&& localStorage.getItem('tokenData') !== null) {
      const tokenData = JSON.parse(localStorage.getItem('tokenData'));
      this.props.setLoginStatus(true, tokenData.localId.replace('fkiG', ''), tokenData.idToken, tokenData.expire);
      axios.get('/users/'+ tokenData.localId.replace('fkiG', '') +'.json?auth='+ tokenData.idToken)
      .then(response => {
          this.props.setUserData(response.data);
      });
      
    window.timer = setTimeout(()=>{
      if(tokenData.expire - new Date().getTime() > 0) alert('Session expired. Please login again');
          this.props.setLoginStatus(false, null, null);
          localStorage.clear();
      }, tokenData.expire - new Date().getTime())
    }
  }

  componentDidUpdate() {
    if(this.props.loginStatus.isLoggedIn) {
      setTimeout(()=>{
        alert('Session expired. Please login again');
        this.props.setLoginStatus(false, null, null);
        localStorage.clear();
    }, this.props.loginStatus.expiresIn - new Date().getTime())
    }
  }

  render(){
    
  return (
    <BrowserRouter>
    <div className="App">
      {
       this.props.loginStatus.isLoggedIn ? <Header /> : null
      }
      <main>
        <Switch>
        <Route path="/" exact component = {Main}/>
        {
          !this.props.loginStatus.isLoggedIn ?
          <Route path="/signup" component={Signup}/>
          : null
        }
        <Route path="/feed" component={Feed} />
        <Route path="/profile" component={MyProfile} />
        <Route path="/account/:userId" component={UserProfile} />
        <Route path="/messages" component={Messages} />      
        <Route path="/explore" component={Explore} />
        <Route path="/fi-admin" component={Admin} />    
        <Route render={()=><h1 style={{margin: '100px 0',color:'grey'}}>404<br /> Page Not Found</h1>}/>
       </Switch>
      </main>
    </div>
    </BrowserRouter>
  );
 }
}

const mapStateToProps = state => {
  return {
      loginStatus: state.loginStatus
  }
}
const mapDispatchToProps = dispatch => {
  return {
      setLoginStatus: (isLoggedIn, userId, authToken, expiresIn) => 
                      dispatch({
                          type: 'SET_LOGIN_STATUS',
                          isLoggedIn: isLoggedIn,
                          localId: userId,
                          idToken: authToken,
                          expiresIn: expiresIn
                      }),
      setUserData: (value) => dispatch({type: 'SET_USER_DATA', value:value})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
